import { call, ClickEventType } from "goi_common";
import { useGoiCallModal } from "./useGoiCallModal";

export const useGoiCall = (
  {
    showModal,
    phone,
    path,
  }: {
    showModal?: boolean;
    phone?: string;
    path?: ClickEventType["path"];
  } = {
    showModal: true,
    phone: "1666-9784",
    path: "snackbar",
  },
) => {
  const { onQuickCallModal } = useGoiCallModal({
    callTo: phone,
    path,
  });

  const goiCall = () => {
    if (showModal) {
      onQuickCallModal();

      return;
    } else {
      call(phone || "1666-9784");
    }
  };

  return { goiCall };
};
